export const googleConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  scopes: process.env.REACT_APP_CALENDAR_SCOPES?.split(' ') || [
    'https://www.googleapis.com/auth/calendar',
    'https://www.googleapis.com/auth/calendar.events'
  ],
  redirectUri: process.env.REACT_APP_CALENDAR_REDIRECT_URI || window.location.origin
};

export const outlookConfig = {
  clientId: process.env.REACT_APP_OUTLOOK_CLIENT_ID,
  clientSecret: process.env.REACT_APP_OUTLOOK_CLIENT_SECRET,
  redirectUri: process.env.REACT_APP_CALENDAR_REDIRECT_URI || window.location.origin
}; 